// extracted by mini-css-extract-plugin
export default {"primary-color":"#006266","secondaryColor":"#ff8945","container":"event-role-icon_component_container__qxyLW"};